import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, orderPickupButtonMobile } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/GUfIuu3VqNzD8LkFNvTM/locations/DEEo3TZ6FYLSijU636WJ`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="255px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/GUfIuu3VqNzD8LkFNvTM/locations/DEEo3TZ6FYLSijU636WJ`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} w="280px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
